import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  ApiKey,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
} from "@/types/apiAgent";
import { api } from "@/lib/http";

export const apiKeysQueryOptions = {
  queryKey: ["api-keys"] as const,
  queryFn: async (): Promise<Array<ApiKey>> => {
    const response = await api.apiSvc
      .get("v1/my-api-keys/")
      .json<Array<ApiKey>>();
    return response;
  },
};

export const useApiKeys = () => {
  return useQuery(apiKeysQueryOptions);
};

export const useCreateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: CreateApiKeyRequest,
    ): Promise<CreateApiKeyResponse> => {
      const response = await api.apiSvc
        .post("v1/my-api-keys/", {
          json: data,
        })
        .json<CreateApiKeyResponse>();
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
};

export const useDeleteApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<void> => {
      await api.apiSvc.delete(`v1/my-api-keys/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
};
